module.exports = __webpack_public_path__ + "static/the-great-book-of-amber-6fcb6d8c8e557c39a4b0d800a35d4f40.jpg";